import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\UpdateDocumentOrderController::__invoke
* @see app/Http/Controllers/Document/UpdateDocumentOrderController.php
* @route '/api/document/update-order'
*/
const UpdateDocumentOrderController = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDocumentOrderController.url(options),
    method: 'put',
})

UpdateDocumentOrderController.definition = {
    methods: ["put"],
    url: '/api/document/update-order',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Document\UpdateDocumentOrderController::__invoke
* @see app/Http/Controllers/Document/UpdateDocumentOrderController.php
* @route '/api/document/update-order'
*/
UpdateDocumentOrderController.url = (options?: RouteQueryOptions) => {
    return UpdateDocumentOrderController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\UpdateDocumentOrderController::__invoke
* @see app/Http/Controllers/Document/UpdateDocumentOrderController.php
* @route '/api/document/update-order'
*/
UpdateDocumentOrderController.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDocumentOrderController.url(options),
    method: 'put',
})

export default UpdateDocumentOrderController